import { Card } from '@dreamtree-org/twreact-ui';

/**
 * The app's surface.
 *
 * twreact-ui's Card hardcodes `bg-white border-gray-200` and the library ships
 * no dark-theme CSS of its own, so every Card would stay white while the rest
 * of the app went dark. Its `className` runs through tailwind-merge, though,
 * which means a class passed in genuinely REPLACES the built-in one rather than
 * racing it in the stylesheet.
 *
 * So this is the one place that retint happens. Every screen uses Panel; no
 * screen repeats the token classes, and none can forget them.
 */
export default function Panel({ className = '', children, ...rest }) {
  return (
    <Card
      className={`border-[var(--app-border)] bg-[var(--app-surface)] text-[var(--app-text)] ${className}`}
      {...rest}
    >
      {children}
    </Card>
  );
}
